import Route from '@/generated/classes/Route';
import { PdfNotif as PdfNotifBase } from '@/generated/classes/Route';
export default class RouteExtend extends Route {
  constructor() {
    super();
  }
}
export class PdfNotif extends PdfNotifBase {
  constructor() {
    super();
  }
}
